import { isBoolean } from 'lodash';
import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

export function Timepicker(props) {
  const { placeHolder, rowIndex, colIndex, onChange, CustomAddEditAccess, gridY } = props;

  const timeSelectd = props?.value ? new Date(props?.value) : null;
  return (
    <div className="dt_picker position-relative">
      <DatePicker
        popperPlacement={gridY > 30 ? 'top-end' : 'bottom-end'}
        name="selectedDate"
        showTimeSelect
        selected={timeSelectd}
        disable={isBoolean(CustomAddEditAccess) ? !CustomAddEditAccess : false}
        readOnly={isBoolean(CustomAddEditAccess) ? !CustomAddEditAccess : false}
        placeholderText={placeHolder}
        timeIntervals={5}
        timeCaption="Time"
        timeFormat="HH:mm"
        dateFormat="HH:mm"
        onChange={(e) => onChange(e, rowIndex, colIndex)}
        showTimeSelectOnly
      />
      <button type="button" className="btn-calender btn custom-time-icon">
        <i className="icon-clock" />
      </button>
    </div>
  );
}
export default Timepicker;
